export default "__VITE_ASSET__9n9TeSKc__"